const ErrorMessage = ({ message }) => {
  return <span className="error text-left">{message}</span>;
};

export default ErrorMessage;
